import {FC, useEffect} from "react";
import Layout from "../../../common/layouts/Layout";
import Navbar from "../../../common/Navbar/Navbar";
import {Card, CardContent, Container, Divider, Typography, Grid, Button} from "@mui/material";
import UploadFile from "../../../common/UploadFile/UploadFile";
import { useFindOneMeetingQuery } from "../../../../generated/graphql";
import { useParams } from "react-router-dom";
import useAppStore from "../../../../states/zustand/appStore";
import Moment from "../../../common/Moment/Moment";
import { downloadFile, getFileName, romanize } from "../../../../utils/helper";

const MeetingDetails: FC = (): JSX.Element => {
    const {id} = useParams() as any;
    const { setLoader } = useAppStore();
    const {data, error, loading} = useFindOneMeetingQuery({
        variables: {
            _id:id
        }
    })

    useEffect(() => {
        setLoader(loading);
    }, [loading]);

    return (
        <Layout>
            <>
                <Navbar pageTitle={"Meeting"}/>
                <Container maxWidth={false}>
                    <Card>
                        <CardContent className="pd-x-32 pd-t-32 pd-b-20">
                            <Typography className="mg-b-10" variant="h2" component="h2">
                                {data?.findOneMeeting?.meetingId?.toUpperCase()}
                            </Typography>
                            <Divider className={`mg-b-32`} />
                            <Grid container spacing={3}>
                                <Grid item xs={12} md={4}>
                                    <Typography variant={"h4"} component={"h4"} className={`mg-b-6`}>1.  Meeting ID</Typography>
                                    <Typography variant={"body2"} component={"p"} color={"secondary"} className={`font-weight-semi-bold`}>{data?.findOneMeeting.meetingId.toUpperCase()}</Typography>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography variant={"h4"} component={"h4"} className={`mg-b-6`}>2.  Meeting Date</Typography>
                                    <Typography variant={"body2"} component={"p"} color={"secondary"} className={`font-weight-semi-bold`}><Moment format="h:mm A, MMM DD, YYYY" date={data?.findOneMeeting?.meetingDate}/></Typography>
                                </Grid>
                                {/* <Grid item xs={12} md={4}>
                                    <Typography variant={"h4"} component={"h4"} className={`mg-b-6`}>3.  Last date of submission</Typography>
                                    <Typography variant={"body2"} component={"p"} color={"secondary"} className={`font-weight-semi-bold`}><Moment format="h:mm A, MMM DD, YYYY" date={data?.findOneMeeting?.lastSubmissionDate}/></Typography>
                                </Grid> */}
                                <Grid item xs={12} md={4}>
                                    <Typography variant={"h4"} component={"h4"} className={`mg-b-6`}>4.  Agenda</Typography>
                                    {data?.findOneMeeting.agenda ?
                                    <Typography variant={"body2"} component={"p"} color={"secondary"} className={`font-weight-semi-bold`}>
                                            <Button onClick={()=>downloadFile(data?.findOneMeeting?.agenda)} variant='text' color="error" className={`pd-x-0`} sx={{textTransform: 'initial'}}>
                                                <i className={`icon-download mg-r-10`}></i>{getFileName(data?.findOneMeeting?.agenda)}
                                            </Button>
                                    </Typography>: 
                                    <Typography variant={"body2"} component={"p"} color='GrayText' className={`font-weight-semi-bold`}>
                                       N/A
                                    </Typography>}
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography variant={"h4"} component={"h4"} className={`mg-b-6`}>5.  Minutes of Meeting (MOM)</Typography>
                                    {data?.findOneMeeting.mom ? 
                                    <Typography variant={"body2"} component={"p"} color={"secondary"} className={`font-weight-semi-bold`}>
                                        <Button onClick={()=>downloadFile(data?.findOneMeeting?.mom)} variant='text' color="error" sx={{textTransform: 'initial'}}className={`pd-x-0`}>
                                            <i className={`icon-download mg-r-10`}></i>{getFileName(data?.findOneMeeting?.mom)}
                                        </Button>
                                    </Typography>: 
                                    <Typography variant={"body2"} component={"p"} color='GrayText' className={`font-weight-semi-bold`}>
                                       N/A
                                    </Typography>}
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Typography variant={"h4"} component={"h4"} className={`mg-b-6`}>6.  Project</Typography>
                                    <Typography variant={"body2"} component={"p"} color={"secondary"} className={`font-weight-semi-bold`}>{
                                        data?.findOneMeeting?.projects?.map(p => p._id.title)?.join(", ")
                                    }</Typography>
                                </Grid>
                            </Grid>
                            <Divider className={`mg-y-32`} />
                            {
                             data?.findOneMeeting?.projects?.map(p => {
                                return (
                                    <Card key={p._id._id} className={'mg-b-20'}>
                                        <CardContent>
                                            <Typography variant={"h4"} component={"h4"} className={`mg-b-6`}>  Documents Submitted - {p._id.title}</Typography>
                                            <ul className={`list-style-none mg-b-10 submissionList`}>
                                                {
                                                    p.documents.map((d, i) => {
                                                        return (
                                                            <li key={d.url}>
                                                                <Grid container spacing={2} className={`align-items-center justify-content-between`}>
                                                                    <Grid item xs={12} md={"auto"}>
                                                                        <label className="form-label mg-b-0 font-size-14">{romanize(i+1)}).  {
                                                                            d.label
                                                                        } :</label>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={"auto"}>
                                                                        <div className={`d-flex justify-content-between align-items-center`}>
                                                                        <Button onClick={()=>downloadFile(d.url)} variant='text' color="error" className={`pd-x-0`} sx={{textTransform: 'initial'}}>
                                                                            <i className={`icon-download mg-r-10`}></i>{getFileName(d.url)}
                                                                        </Button>
                                                                        </div>
                                                                    </Grid>
                                                                </Grid>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </CardContent>
                                    </Card>
                                )
                             })   
                            }
                        </CardContent>
                    </Card>
                </Container>
            </>
        </Layout>
    )
}

export default MeetingDetails;